module.exports={
  "Réseau JP Sarthe": "http://www.crjp72.com",
  "PlatO - Plateforme jeune public des Pays de la Loire": "http://www.plato-jp.fr",
  "Scène d'Enfance - Assitej France": "http://www.scenesdenfance-assitej.fr/",
  "PJP 49": "https://www.facebook.com/PJP49-Partenaires-Jeune-Public-Maine-et-Loire-464396247313397",
  "RAMDAM": "http://ramdam.pro/",
  "Enfance et musique": "http://www.enfancemusique.asso.fr/",
  "Collectif des médiateurs jeune public des Pays de la Loire": "",
  "Collectif Pays du môme": "https://www.paysdumome.com/",
  "Réseau des programmateurs jeune public 44": "",
  "Les Scènes appartagées": "https://www.facebook.com/lesscenesappartagees/",
  "PÉCANS": "https://www.sarthe.fr/le-projet-pecans-culture-et-arts-au-college"
}
